import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-admin-manage-shippigo',
  templateUrl: './admin-manage-shippigo.component.html',
  styleUrls: ['./admin-manage-shippigo.component.scss'],
})
export class AdminManageShippigoComponent implements OnInit {

  carrierNameError: string;
  userNameError: string;
  passwordError: string;
  carrierId: any;
  shippigoData: any = {};

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.adminGetCarrierInfoById(this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.shippigoData = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.shippigoData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  userNameBlur() {
    this.userNameError = "";
    if (!this.shippigoData.username) {
      this.userNameError = 'Please enter user name';
    }
  }

  passwordBlur() {
    this.passwordError = "";
    if (!this.shippigoData.password) {
      this.passwordError = 'Please enter password';
    }
  }

  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.userNameError = "";
    this.passwordError = "";

    if (!this.shippigoData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.shippigoData.username) {
      this.userNameError = 'Please enter user name';
    }
    if (!this.shippigoData.password) {
      this.passwordError = 'Please enter password';
    }
    if (this.carrierNameError != "" || this.userNameError != "" || this.passwordError != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {
      "username": this.shippigoData.username,
      "carrierCode": this.shippigoData.carrierCode,
      "connectionName": this.shippigoData.connectionName,
      "organizationId": this.shippigoData.organizationId,
      "password": this.shippigoData.password,
      "carrierId": this.shippigoData.carrierId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shippigo', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }
}

